import SignOutConfirmationModal from './SignOutConfirmationModal';

export default SignOutConfirmationModal;
